import apiClient from './client'
import type { ApiResponse } from '@/types/api'
import type { User } from '@/types/auth'

export interface RegisterPayload {
  email: string
  password: string
  password_confirmation: string
  first_name: string
  last_name: string
  language?: string
}

export interface LoginPayload {
  email: string
  password: string
}

export interface LoginResponse {
  access_token: string
  token_type: string
  user: User
}

export const authApi = {
  register: (payload: RegisterPayload) =>
    apiClient.post<ApiResponse<User>>('/auth/register', payload),

  login: (payload: LoginPayload) =>
    apiClient.post<ApiResponse<LoginResponse>>('/auth/login', payload),

  logout: () => apiClient.post<void>('/auth/logout'),

  me: () => apiClient.get<ApiResponse<User>>('/me'),

  verifyEmail: (token: string) =>
    apiClient.post<ApiResponse<null>>('/auth/email/verify', { token }),

  forgotPassword: (email: string) =>
    apiClient.post<ApiResponse<null>>('/auth/password/forgot', { email }),

  resetPassword: (payload: {
    token: string
    email: string
    password: string
    password_confirmation: string
  }) => apiClient.post<ApiResponse<null>>('/auth/password/reset', payload),
}
